/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

export type PublicationWarning = typeof PublicationWarning[keyof typeof PublicationWarning];


export const PublicationWarning = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_4: 4,
} as const;
